<template>
  <div ref="filterElement">
    <span class="p-input-icon-left position-relative">
      <i class="pi pi-filter" @click="showList = !showList" />
      <InputText
        @click="showList = !showList"
        type="text"
        :value="selectedFilters"
        placeholder="Filter applications"
        readonly
      />
    </span>
    <Card v-if="showList" class="filter-style">
      <template #content>
        <div class="option-title">Filter by application status</div>
        <SingleCheckbox
          v-for="status of applicationStatuses"
          :label="status.label"
          :key="status.value"
          :value="status.checked"
          @getInputValue="updateData('status', $event, status.value)"
        />
        <div class="mt-3 option-title">Filter by loan stage</div>
        <SingleCheckbox
          v-for="stage of loanStages"
          :label="stage.label"
          :key="stage.value"
          :value="stage.checked"
          @getInputValue="updateData('stage', $event, stage.value)"
        />
      </template>
    </Card>
  </div>
</template>

<script>
import Card from 'primevue/card';
import InputText from 'primevue/inputtext';

export default {
  name: 'Filter',
  components: {
    Card,
    InputText,
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  data() {
    return {
      showList: false,
      applicationStatuses: [
        {
          label: 'Open',
          value: 'open',
          checked: false,
        },
        {
          label: 'Repaid',
          value: 'loan_repaid',
          checked: false,
        },
        {
          label: 'Dropped Off',
          value: 'dropped_off',
          checked: false,
        },
        {
          label: 'Withdrawn',
          value: 'withdrawn',
          checked: false,
        },
        {
          label: 'Rejected',
          value: 'rejected',
          checked: false,
        },
      ],
      loanStages: [
        {
          label: 'Application submission',
          value: 'application_submission',
          checked: false,
        },
        {
          label: 'Conditional offer',
          value: 'conditional_offer',
          checked: false,
        },
        {
          label: 'Supporting documents',
          value: 'supporting_documents',
          checked: false,
        },
        {
          label: 'Unconditional offer',
          value: 'unconditional_offer',
          checked: false,
        },
        {
          label: 'Loan settlement',
          value: 'settlement_booked',
          checked: false,
        },
      ],
    };
  },
  computed: {
    selectedFilters() {
      const statuses = this.applicationStatuses.filter((item) => item.checked === true).map((item) => item.label);
      const stages = this.loanStages.filter((item) => item.checked === true).map((item) => item.label);
      return [...statuses, ...stages].join(', ');
    },
  },
  methods: {
    handleClickOutside(event) {
      const filterElement = this.$refs.filterElement;
      if (filterElement && !filterElement.contains(event.target)) {
        this.showList = false;
      }
    },
    updateData(event, checked, field) {
      if (event === 'status') {
        const index = this.applicationStatuses.findIndex((item) => item.value === field);
        this.applicationStatuses[index].checked = checked;
      } else {
        const index = this.loanStages.findIndex((item) => item.value === field);
        this.loanStages[index].checked = checked;
      }
      const stages = this.loanStages.filter((item) => item.checked === true).map((item) => item.value);
      const submissionIndex = stages.findIndex((item) => item === 'application_submission');
      if (submissionIndex > -1) {
        stages.splice(submissionIndex, 1);
        stages.push('assessment_ready', 'workshopping_application');
      }
      this.$emit(
        event,
        event === 'status'
          ? this.applicationStatuses.filter((item) => item.checked === true).map((item) => item.value)
          : stages,
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/global.scss';
.p-card {
  border-radius: 4px !important;
  color: $primary-text-color !important;
  font-family: $font-family !important;
  min-height: 282px !important;
}

:deep(.p-card-content) {
  font-size: 15px !important;
}
.filter-style {
  position: absolute !important;
  z-index: 10;
  width: 280px;
}
.option-title {
  color: rgba(2, 0, 56, 0.3);
  font-weight: 600;
  font-size: 14px;
}
.p-inputtext:enabled:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.1rem #ced4da !important;
  border-color: #ced4da !important;
}
:deep(.p-card .p-card-body) {
  padding: 1rem;
  padding-bottom: 0rem;
  margin-bottom: -0.5rem;
}
</style>
